import { getClaimedByDisplayName } from "@/features/homeowners/lib/claimed-by-display"
import { getDisplayAddressValue } from "@/features/homeowners/lib/unknown-location"

type WorkscopeDefinition = {
  label: string
  statusPath: string
  claimedByPath: string
  datePath: string
}

export type WorkscopeStatusBucket = "complete" | "inProgress" | "notStarted" | "unknown"

export type ClaimedWorkscopeItem = {
  organization: string
  homeId: number
  homeownerUserId: number | null
  homeownerName: string
  address: string
  workscope: string
  status: string
  bucket: WorkscopeStatusBucket
  dateCompleted: string | null
}

export type ClaimedByReportFilters = {
  workscopes: string[]
  dateCompletedFrom: string
  dateCompletedTo: string
}

export const WORKSCOPE_DEFINITIONS: WorkscopeDefinition[] = [
  { label: "Tree", statusPath: "treeDebrisInfo.treeWorkNeeded", claimedByPath: "treeDebrisInfo.treeClaimedBy", datePath: "treeDebrisInfo.treeWorkNeededDateCompleted" },
  { label: "Exterior Debris", statusPath: "treeDebrisInfo.exteriorDebrisRemovalNeeded", claimedByPath: "treeDebrisInfo.debrisClaimedBy", datePath: "treeDebrisInfo.exteriorDebrisRemovalNeededDateCompleted" },
  { label: "Heavy Equipment", statusPath: "treeDebrisInfo.heavyEquipmentNeeded", claimedByPath: "treeDebrisInfo.heavyClaimedBy", datePath: "treeDebrisInfo.heavyEquipmentNeededDateCompleted" },
  { label: "Roof Tarp", statusPath: "roofingInfo.roofTarpNeeded", claimedByPath: "roofingInfo.roofTarpClaimedBy", datePath: "roofingInfo.roofTarpNeededDateCompleted" },
  { label: "Roofing", statusPath: "roofingInfo.roofing", claimedByPath: "roofingInfo.roofingClaimedBy", datePath: "roofingInfo.roofingDateCompleted" },
  { label: "Muck & Gut", statusPath: "muckGutInfo.muckGutNeeded", claimedByPath: "muckGutInfo.claimedBy", datePath: "muckGutInfo.muckGutNeededDateCompleted" },
  { label: "Mold Remediation", statusPath: "moldRemediationInfo.moldRemediation", claimedByPath: "moldRemediationInfo.claimedBy", datePath: "moldRemediationInfo.moldRemediationDateCompleted" },
  { label: "Rebuild Prep", statusPath: "rebuildPrepInfo.rebuildPrep", claimedByPath: "rebuildPrepInfo.claimedBy", datePath: "rebuildPrepInfo.rebuildPrepDateCompleted" },
  { label: "Rough Carpentry", statusPath: "roughCarpentryInfo.roughCarpentry", claimedByPath: "roughCarpentryInfo.claimedBy", datePath: "roughCarpentryInfo.roughCarpentryDateCompleted" },
  { label: "Electrical", statusPath: "electricalInfo.electrical", claimedByPath: "electricalInfo.claimedBy", datePath: "electricalInfo.electricalDateCompleted" },
  { label: "Rough Electrical", statusPath: "electricalInfo.electricalRoughIn", claimedByPath: "electricalInfo.electricalRoughInClaimedBy", datePath: "electricalInfo.electricalRoughInDateCompleted" },
  { label: "HVAC", statusPath: "hvacInfo.hvac", claimedByPath: "hvacInfo.claimedBy", datePath: "hvacInfo.hvacDateCompleted" },
  { label: "Rough Mechanical", statusPath: "hvacInfo.mechanicalRoughIn", claimedByPath: "hvacInfo.mechanicalRoughInClaimedBy", datePath: "hvacInfo.mechanicalRoughInDateCompleted" },
  { label: "Plumbing", statusPath: "plumbingInfo.plumbing", claimedByPath: "plumbingInfo.claimedBy", datePath: "plumbingInfo.plumbingDateCompleted" },
  { label: "Rough Plumbing", statusPath: "plumbingInfo.plumbingRoughIn", claimedByPath: "plumbingInfo.plumbingRoughInClaimedBy", datePath: "plumbingInfo.plumbingRoughInDateCompleted" },
  { label: "Crawl Space Muck", statusPath: "crawlSpaceInfo.crawlSpaceMuck", claimedByPath: "crawlSpaceInfo.crawlSpaceMuckClaimedBy", datePath: "crawlSpaceInfo.crawlSpaceMuckDateCompleted" },
  { label: "Crawl Space Insulation", statusPath: "crawlSpaceInfo.crawlSpaceInsulation", claimedByPath: "crawlSpaceInfo.crawlSpaceInsulationClaimedBy", datePath: "crawlSpaceInfo.crawlSpaceInsulationDateCompleted" },
  { label: "Insulation", statusPath: "insulationInstallInfo.insulationInstall", claimedByPath: "insulationInstallInfo.claimedBy", datePath: "insulationInstallInfo.insulationInstallDateCompleted" },
  { label: "Drywall Hanging", statusPath: "drywallHangingInfo.drywallHanging", claimedByPath: "drywallHangingInfo.claimedBy", datePath: "drywallHangingInfo.drywallHangingDateCompleted" },
  { label: "Mud & Tape", statusPath: "mudAndTapeInfo.mudAndTape", claimedByPath: "mudAndTapeInfo.claimedBy", datePath: "mudAndTapeInfo.mudAndTapeDateCompleted" },
  { label: "Bathroom Rebuild", statusPath: "bathroomRebuildInfo.bathroomRebuild", claimedByPath: "bathroomRebuildInfo.claimedBy", datePath: "bathroomRebuildInfo.bathroomRebuildDateCompleted" },
  { label: "Cabinet Install", statusPath: "cabinetInstallInfo.cabinetInstall", claimedByPath: "cabinetInstallInfo.cabinetClaimedBy", datePath: "cabinetInstallInfo.cabinetInstallDateCompleted" },
  { label: "Counter Install", statusPath: "cabinetInstallInfo.counterInstall", claimedByPath: "cabinetInstallInfo.counterClaimedBy", datePath: "cabinetInstallInfo.counterInstallDateCompleted" },
  { label: "Appliance Install", statusPath: "cabinetInstallInfo.applianceInstall", claimedByPath: "cabinetInstallInfo.applianceClaimedBy", datePath: "cabinetInstallInfo.applianceInstallDateCompleted" },
  { label: "Interior Paint", statusPath: "interiorPaintInfo.interiorPaint", claimedByPath: "interiorPaintInfo.claimedBy", datePath: "interiorPaintInfo.interiorPaintDateCompleted" },
  { label: "Interior Doors", statusPath: "installInteriorDoorsInfo.installInteriorDoors", claimedByPath: "installInteriorDoorsInfo.claimedBy", datePath: "installInteriorDoorsInfo.installInteriorDoorsDateCompleted" },
  { label: "Trim Install", statusPath: "trimInstallInfo.trimInstall", claimedByPath: "trimInstallInfo.claimedBy", datePath: "trimInstallInfo.trimInstallDateCompleted" },
  { label: "Flooring Install", statusPath: "flooringInstallInfo.flooringInstall", claimedByPath: "flooringInstallInfo.claimedBy", datePath: "flooringInstallInfo.flooringInstallDateCompleted" },
  { label: "Exterior Door Install", statusPath: "exteriorDoorInstallInfo.exteriorDoorInstall", claimedByPath: "exteriorDoorInstallInfo.claimedBy", datePath: "exteriorDoorInstallInfo.exteriorDoorInstallDateCompleted" },
  { label: "Shutter Install", statusPath: "stormShutters.shutterInstall", claimedByPath: "stormShutters.shuttersClaimedBy", datePath: "stormShutters.shutterInstallDateCompleted" },
  { label: "Driveway Repair", statusPath: "drivewayRepair.drivewayRepair", claimedByPath: "drivewayRepair.drivewayClaimedBy", datePath: "drivewayRepair.drivewayRepairDateCompleted" },
  { label: "Miscellaneous", statusPath: "miscellaneousInfo.miscellaneous", claimedByPath: "miscellaneousInfo.claimedBy", datePath: "miscellaneousInfo.miscellaneousDateCompleted" },
]

function getNestedValue(obj: unknown, path: string): unknown {
  return path.split(".").reduce((current: unknown, key) => (current as Record<string, unknown>)?.[key], obj)
}

function normalizeClaimedBy(raw: unknown): string[] {
  if (raw == null) return []
  if (Array.isArray(raw)) return raw.flatMap(normalizeClaimedBy)
  if (typeof raw !== "string") return []

  const value = raw.trim()
  if (!value) return []

  try {
    return normalizeClaimedBy(JSON.parse(value))
  } catch {
    return [value]
  }
}

function getHomeownerName(home: any): string {
  const firstName = home.homeowner?.firstName || home.homeowner?.first_name || ""
  const lastName = home.homeowner?.lastName || home.homeowner?.last_name || ""
  const fullName = `${firstName} ${lastName}`.trim()
  return fullName || home.homeowner?.user?.fullname || home.homeowner?.name || `Home #${home.id}`
}

function getHomeownerUserId(home: any): number | null {
  const rawUserId = home.homeowner?.user?.id ?? home.homeowner?.userId ?? null
  const userId = Number(rawUserId)
  return Number.isFinite(userId) ? userId : null
}

function bucketStatus(status: string): WorkscopeStatusBucket {
  if (status === "Complete" || status === "Materials Only Complete") return "complete"
  if (["25%", "50%", "75%", "Materials Only"].includes(status)) return "inProgress"
  if (status === "Needed Not Started" || status === "Reassessment Needed") return "notStarted"
  return "unknown"
}

function normalizeCalendarDate(raw: unknown): string | null {
  if (typeof raw !== "string") return null
  const match = raw.trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return null

  const [, year, month, day] = match
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  if (
    date.getFullYear() !== Number(year)
    || date.getMonth() !== Number(month) - 1
    || date.getDate() !== Number(day)
  ) {
    return null
  }

  return `${year}-${month}-${day}`
}

export function formatCalendarDate(value: string | null): string {
  if (!value) return "—"
  const [year, month, day] = value.split("-").map(Number)
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

export function buildClaimedWorkscopeItems(homes: any[]): ClaimedWorkscopeItem[] {
  return homes.flatMap((home) => {
    return WORKSCOPE_DEFINITIONS.flatMap((definition) => {
      const claimedByValues = normalizeClaimedBy(getNestedValue(home, definition.claimedByPath))
        .filter((value) => value !== "No Need")
      if (claimedByValues.length === 0) return []

      const rawStatus = getNestedValue(home, definition.statusPath)
      const status = typeof rawStatus === "string" && rawStatus.trim()
        ? rawStatus.trim()
        : "Unknown"

      if (status === "No Assistance Required") return []

      return claimedByValues.map((organization) => ({
        organization: getClaimedByDisplayName(organization),
        homeId: home.id,
        homeownerUserId: getHomeownerUserId(home),
        homeownerName: getHomeownerName(home),
        address: getDisplayAddressValue(home.address) || "",
        workscope: definition.label,
        status,
        bucket: bucketStatus(status),
        dateCompleted: normalizeCalendarDate(getNestedValue(home, definition.datePath)),
      }))
    })
  })
}

export function filterClaimedWorkscopeItems(
  items: ClaimedWorkscopeItem[],
  filters: ClaimedByReportFilters,
): ClaimedWorkscopeItem[] {
  const selectedWorkscopes = new Set(filters.workscopes)
  return items.filter((item) => {
    if (selectedWorkscopes.size > 0 && !selectedWorkscopes.has(item.workscope)) return false

    if (filters.dateCompletedFrom || filters.dateCompletedTo) {
      if (!item.dateCompleted) return false
      if (filters.dateCompletedFrom && item.dateCompleted < filters.dateCompletedFrom) return false
      if (filters.dateCompletedTo && item.dateCompleted > filters.dateCompletedTo) return false
    }

    return true
  })
}
